import { Checkbox, CheckboxGroup, FormControl, Input, Select, Textarea, type FormControlProps, type InputProps } from '@eqi-investimentos/react';
import { SimpleGrid } from '@chakra-ui/react';
import { type Control, Controller, type Path } from 'react-hook-form';
export const GenericController = <T extends Record<string, unknown>,>({
  control,
  name,
  errorMessage,
  helperText,
  id,
  inputProps,
  isRequired = true,
  label,
  labelVariant = 'floating',
  max,
  min,
  options,
  placeholder,
  size = 'lg',
  type = 'text',
  mask
}: GenericControllerProps<T>) => <FormControl key={name} id={name} label={label} variant={type === 'checkbox' ? 'fixed' : labelVariant} helperText={helperText} {...{
  errorMessage,
  size,
  isRequired
}} data-sentry-element="FormControl" data-sentry-component="GenericController" data-sentry-source-file="index.tsx">
    <Controller name={name} control={control}
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  render={({
    field: {
      ref,
      value,
      onChange,
      ...props
    }
  }) => {
    if (type === 'select') return <Select size={size} options={options || []} placeholder={placeholder} value={value as string} onChange={onChange} {...props} />;
    if (type === 'checkbox') return <CheckboxGroup onChange={onChange} value={Array.isArray(value) ? value : []} {...props}>
              <SimpleGrid columns={2} gap={6}>
                {options?.map(({
          name,
          value: optionsValue
        }) => <Checkbox key={optionsValue} value={optionsValue} size={size} side="left">
                    {name}
                  </Checkbox>)}
              </SimpleGrid>
            </CheckboxGroup>;
    if (type === 'date') {
      return <Input type="date" size={size} placeholder={placeholder} {...props} value={value && (typeof value === 'number' || typeof value === 'string') ? new Date(value).toISOString().substring(0, 10) : ''} onChange={({
        target: {
          value
        }
      }) => {
        const dateValue = value ? new Date(`${value}T00:00:00`).getTime() : undefined;
        onChange(dateValue);
      }} />;
    }
    if (type === 'textarea') {
      return <Textarea aria-label={`textarea-form-immobilized-${id}`} name={id} placeholder={labelVariant === 'floating' ? '' : placeholder} minH="7.5rem" noOfLines={12} value={value as string | number} onChange={({
        target
      }) => onChange(target.value)} />;
    }
    return <Input type={type} size={size} value={value as string | number} min={min} max={max} onChange={({
      target: {
        value
      }
    }) => {
      onChange(mask ? mask(`${value || ''}`) : value);
    }} {...props} {...inputProps} />;
  }} data-sentry-element="Controller" data-sentry-source-file="index.tsx" />
  </FormControl>;
export type GenericControllerProps<T extends Record<string, unknown>> = Pick<FormControlProps, 'isRequired' | 'size' | 'errorMessage'> & {
  control: Control<T>;
  name: Path<T>;
  type?: 'checkbox' | 'select' | 'textarea' | InputProps['type'];
  helperText?: FormControlProps['helperText'];
  id?: string;
  inputProps?: InputProps;
  label: string;
  labelVariant?: FormControlProps['variant'];
  max?: number;
  min?: number;
  options?: {
    name: string;
    value: string;
  }[];
  placeholder?: string;
  mask?: (value: string) => string;
};